import React from 'react'
import { Space } from 'antd'
import { useFetchTextSubmissionDetailsQuery } from '../../../../../store/apis/submission.api'
import { useFetchQuestionsQuery } from '../../../../../store/apis/question.api'
import { useParams } from 'react-router'
import { useVersionId } from '../../../../../utils/parseURL.helper'
import { getCategoryById } from '../../../../../store/apis/utils/selectors/question.api.selectors'
import { useSelector } from 'react-redux'
import submissionSelectors from '../../../../../store/selectors/submission.selectors'
import StatisticsWithProgress from '../../../../../components/common/StatisticsWithProgress'
import { flatten } from '../../../../../utils/array.helper'

const TextSubmissionStatisics = () => {
    const { token } = useParams()
    const versionId = useVersionId()
    const openedSubmissionId = useSelector(submissionSelectors.openedSubmissionId)

    let { data: questions } = useFetchQuestionsQuery({ token, versionId })
    questions = flatten(questions, { excludeParents: true })
    const { data: submission } = useFetchTextSubmissionDetailsQuery({
        submissionId: openedSubmissionId,
    })

    const reviewedAnswersCount = submission?.answers.filter(answer => answer.approveStatus).length

    const grade = submission?.answers.reduce((acc, answer) => {
        const category = getCategoryById(questions, answer.categoryId)
        const categoryGrade = category?.grade || 0
        return acc + categoryGrade
    }, 0)

    const maxGrade = questions?.reduce((acc, question) => acc + question.weight, 0) ?? '...'

    return (
        <Space size='large' className='mr-16'>
            <StatisticsWithProgress
                label='Approved'
                current={reviewedAnswersCount}
                total={questions?.length}
                steps={questions?.length}
                style={{ fontSize: 14 }}
                title="Progress on classifications for full review of this submission"
            />
            <StatisticsWithProgress
                label='Total Grade'
                current={grade}
                total={maxGrade}
                steps={maxGrade}
                style={{ fontSize: 14 }}
            />
        </Space>
    )
}

export default TextSubmissionStatisics
